import type * as yup from 'yup';

import { nutzSchema } from '@/features/Sparten/nutz/schema/schema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';

export const inputSchema = nutzSchema;

export type InputStore = yup.Asserts<typeof inputSchema>;

export const useNutzInputStore = genericStoreFactory(
  () => inputSchema.getDefault(),
  'NutzInputStore',
);
